import PropTypes from "prop-types";
import React from "react";
import SubscriptionSuccess from "../components/SubscriptionSuccess";
import { Flex, useMantineTheme } from "@mantine/core";
import { useStylesPage } from "../utils/mantine/useStylesPage";

const SubscriptionSuccessPage = ({ staticBasePath }) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();

  //css classes
  const { classes: classesPage } = useStylesPage();

  return (
    <>
      <title>vBase Verify App</title>
      <meta
        name="description"
        content="Use vBase Verify to quickly and easily verify stamps!"
      />
      <meta property="og:title" content="vBase Verify App" />
      <meta
        property="og:description"
        content="Use vBase Verify to quickly and easily verify stamps!"
      />

      <Flex
        className={classesPage.page + " main-content"}
        direction="column"
        align={theme.flex.align.center}
      >
        <SubscriptionSuccess staticBasePath={staticBasePath} />
      </Flex>
    </>
  );
};
SubscriptionSuccessPage.propTypes = {
  staticBasePath: PropTypes.object.isRequired,
  djangoContext: PropTypes.object.isRequired,
};
export default SubscriptionSuccessPage;
